import React from 'react';
import { LayoutContextProvider } from './LayoutContext';
import LayoutContent from './LayoutContent';

interface TypeTeste {
  url?: string;
}

const Layout: React.FC<TypeTeste> = ({ url }) => {
  return (
    <LayoutContextProvider>
      <LayoutContent url={url} />
    </LayoutContextProvider>
  );
};

export default Layout;
